import React from 'react'

import { getContrastColor } from 'utils/parsers'

import { Button, Box, Typography } from '@mui/material'

interface ExpiredBlockProps {
  closeTransfer: () => void
}

export const ExpiredBlock = ({ closeTransfer }: ExpiredBlockProps) => {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography mb={1} variant="body1">
        Scanning time is out
      </Typography>
      <Typography mb="112px" variant="body1">
        The scanning session time has expired. Click the "Transfer Ownership" button to initiate the process again.
      </Typography>

      <Button
        onClick={closeTransfer}
        fullWidth
      >
        Go to certificate
      </Button>
    </Box>
  )
}
